import { Grid, StepLabel, styled } from '@mui/material';

export const OfferStepLabel = styled(StepLabel)(() => ({
  pointerEvents: 'none'
}));

export const OfferStepperWrapper = styled(Grid)(({ theme }) => ({
  flexGrow: 1,
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    justifyContent: 'center'
  }
}));
